var objFavoritos;

function GetFavoritos() {
    if (objFavoritos == undefined) {
        objFavoritos = new Favoritos();
    }
    return objFavoritos;
}

function Favoritos() {
    var that = this;
    this.LimpiarFavoritos = function () {
        $.DSt.set(that.AlmacenFavoritos, null);
//        that.ArrayFavoritos= new Array();
//        alert('limpia favoritos');
    }
    this.LoadArrayFavoritos = function () {
        var storedFavoritos = $.DSt.get(that.AlmacenFavoritos);
        if (storedFavoritos != null) {
            that.ArrayFavoritos = eval(JSON.parse(storedFavoritos));
        } else {
            that.ArrayFavoritos = new Array();
        }
        return that.ArrayFavoritos;
    }

    this.AddFavorito = function (idFav, idFeria, texto) {
        var objFavorito = { 'feria': idFeria, 'id': idFav, 'texto': texto };
        that.ArrayFavoritos.push(objFavorito);
        $.DSt.set(that.AlmacenFavoritos, JSON.stringify(that.ArrayFavoritos));
    }

    this.InsertFavorito = function (idEmpresa) {
        var objFavorito = {id: idEmpresa };
        that.ArrayFavoritos.push(objFavorito);
        $.DSt.set(that.AlmacenFavoritos, JSON.stringify(that.ArrayFavoritos));
    }

    this.DeleteFavorito = function (idFav, idFeria) {
        for (var i = that.ArrayFavoritos.length - 1; i >= 0; i--) {
            if (that.ArrayFavoritos[i].feria == idFeria && that.ArrayFavoritos[i].id == idFav)
                that.ArrayFavoritos.splice(i, 1);
        }
        $.DSt.set(that.AlmacenFavoritos, JSON.stringify(that.ArrayFavoritos));
    },

    this.BuscarFavorito = function (idFav, idFeria) {
        var flag = false;
        if (that.ArrayFavoritos != null) {
            for (var i = that.ArrayFavoritos.length - 1; i >= 0; i--) {
                if (that.ArrayFavoritos[i].feria == idFeria && that.ArrayFavoritos[i].id == idFav) {
                    flag = true;
                    break;
                }
            }
        }
        return flag;
    }

    this.BuscarFavoritoTexto = function (idFav, idFeria) {
        var resp = '';
        if (that.ArrayFavoritos != null) {
            for (var i = that.ArrayFavoritos.length - 1; i >= 0; i--) {
                if (that.ArrayFavoritos[i].feria == idFeria && that.ArrayFavoritos[i].id == idFav) {
                    resp = that.ArrayFavoritos[i].texto;
                    break;
                }
            }
        }
        return resp;
    }

    this.obtenerListaFavoritos = function () {
        var listaFavoritos = '';
        for (var i = that.ArrayFavoritos.length - 1; i >= 0; i--) {
            listaFavoritos = listaFavoritos + that.ArrayFavoritos[i].id + ",";
        }
        listaFavoritos = listaFavoritos + "0";
        return listaFavoritos;
    }
};

Favoritos.prototype = {
    ArrayFavoritos: '',
    AlmacenFavoritos: '',
    NumFavoritos: 0,
    MostrarFavoritos: false
}